<template>
  <div class="DASHBOARD-CONTAINER">
    <warnings class="WARNINGS" />
    <transition name="FADE" mode="out-in">
      <div :key="$route.name" class="DASHBOARD">
        <router-view name="sidebar" />
        <router-view name="content" />
      </div>
    </transition>
    <busy-pass-education-modal
        :is-open="shouldNotifyBusyPass"
        @secondary="onBusyPassEducationClose"
        @primary="onBusyPassEducation"
    />
    <availability-modal v-if="isAvailabilityModalOpen" @close="onAvailabilityModalClose" />
  </div>
</template>

<script>
import Warnings from './components/Warnings';
import AvailabilityModal from './components/AvailabilityModal';
import BusyPassEducationModal from './components/BusyPassEducationModal';
import passEducation from './mixins/pass-education';

export default {
  name: 'dashboard',
  components: {
    Warnings,
    AvailabilityModal,
    BusyPassEducationModal,
  },
  mixins: [
    passEducation,
  ],
  data () {
    return {
      isAvailabilityModalOpen: false,
    };
  },
  methods: {
    onBusyPassEducation () {
      this.isAvailabilityModalOpen = true;
      this.setPreviouslyPassed();
      this.resetBusyPassCount();
    },
    onBusyPassEducationClose () {
      this.setPreviouslyPassed();
      if (this.passEducation.busyPassCount > 1) {
        this.resetBusyPassCount();
      }
    },
    onAvailabilityModalClose () {
      this.isAvailabilityModalOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/transitions";

  * {
    -webkit-overflow-scrolling: touch;
  }

  .DASHBOARD-CONTAINER,
  .DASHBOARD {
    display: flex;
    flex: 1 1 auto;
    min-height: 0;
  }

  .DASHBOARD-CONTAINER {
    flex-direction: column;
    overflow: auto;
    background-color: #F5F5F5
  }

  .DASHBOARD {
    @include container;
    position: relative;
  }

  .WARNINGS {
    z-index: 1;
  }
</style>
